import { Routes, Route } from 'react-router-dom';
import StudyCodeCreate from './StudyCodeCreate';
import StudyCodeEdit from './StudyCodeEdit';
import StudyCodeList from './StudyCodeList';

const StudyCodes = () => {
  return (
    <div className="ph4">
      <Routes>
        <Route path="/" element={<StudyCodeList />} />
        <Route path="/create" element={<StudyCodeCreate />} />
        <Route path="/:studyCodeApiId/edit" element={<StudyCodeEdit />} />
      </Routes>
    </div>
  );
};

export default StudyCodes;
